import { render, staticRenderFns } from "./FascicoloDialog.vue?vue&type=template&id=63e20884"
import script from "./FascicoloDialog.vue?vue&type=script&lang=js"
export * from "./FascicoloDialog.vue?vue&type=script&lang=js"
import style0 from "./FascicoloDialog.vue?vue&type=style&index=0&id=63e20884&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports